module.exports = __webpack_public_path__ + "assets/media/team-management.1290ac76.mp4";